import { render, staticRenderFns } from "./marketing-campaigns-container.vue?vue&type=template&id=0c3133e4"
import script from "./marketing-campaigns-container.vue?vue&type=script&lang=js"
export * from "./marketing-campaigns-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports